module.exports = __webpack_public_path__ + "media/images/info_box_white-1f7c106fb935bcfcaf02e8308f3b394b.png";